export const pdfMimeType = 'application/pdf';
